import { Checkbox } from '@dextech-ai/dex-design-system';
import PropTypes from 'prop-types';

// Always-ticked, read-only DS Checkbox that marks an item as already selected.
const SelectedItemCheckbox = ({ 'data-testid': dataTestId }) => (
	<Checkbox data-testid={dataTestId} checked disabled />
);

SelectedItemCheckbox.propTypes = {
	'data-testid': PropTypes.string,
};

export default SelectedItemCheckbox;
